export default {
    language:'bahasa Indonesia',
    // 导航
	zdy:{
        tjsq: "Mengajukan permohonan",
         czsl: "Kuantitas Isi Ulang",
         enterczsl: "Silakan masukkan jumlah isi ulang",
         cz:"Silakan masukkan jumlah isi ulang{min}~{max}",
         qbdz: "Alamat Dompet",
         enterqbdz: "Silakan masukkan alamat dompet",
        sftjmcj:"Apakah akan mengirimkan pesanan harga jual",
        sftjmrj:"Apakah akan mengirimkan harga pembelian pesanan",
		proloss:'Hentikan kerugian',
	},
    header:{
        home:'rumah',
        markets:'Pasar',
        fiat:'Perintah',
        c2c:'C2C',
        exchange:'Menukarkan',
        lever:'Tuas',
        micro:'Perdagangan kontrak kedua',
        myshop:"Toko",
        assets:'Aktiva',
        help:'Membantu',
        login:"Gabung",
        sign:'Daftar',
        accountSet:'Akun',
        tradeLog:'Log transaksi',
        receiveSet:'Koleksi ',
        identify:'Autentikasi',
        jchange:'menukarkan',
        logout:'Keluar',
        themedark:'Mode malam',
        themeday:'Mode Siang',
        bank:"Kartu Binding"
    },
    // 登录注册
    lg:{
        login:'Gabung',
        register:'Daftar',
    },
    // 首页
    home:{
        vol:'24H Vol',
        c01:"Platform perdagangan aset digital terkemuka di dunia",
        c02:'Memberikan layanan perdagangan aset digital dan manajemen aset yang aman dan tepercaya kepada jutaan pengguna di lebih dari 130 negara di seluruh dunia',
        c03:'Aman dan terpercaya',
        c04:'5 tahun pengalaman dalam layanan keuangan aset digital',
        c05:'Arsitektur terdistribusi profesional dan sistem serangan anti-DDOS',
        c06:'Tata letak ekologi global',
        c07:'Sejumlah negara mendirikan pusat layanan transaksi lokal ',
        c08:'untuk membuat ekosistem blockchain dengan berbagai bentuk bisnis',
        c09:'Pelanggan pertama',
        c10:'Menetapkan mekanisme pembayaran preemptive',
        c11:'Siapkan dana perlindungan investor',
        c12:'Perdagangan terminal multi-platform kapan saja, di mana saja',
        c13:'Mencakup berbagai platform iOS, Android, Windows, dan mendukung fungsi bisnis penuh',
        sweep:'Unduh kode pindai',
        android:'Android',
        pinput:'Silakan masukkan email atau nomor ponsel Anda',
        atrade:'Daftarkan Akun Stasiun Global ETHEREUM dan Mulai Perjalanan Perdagangan',
        download:"unduh Aplikasi",
        ios:"IOS 下载",
        androidDownload:"安卓下载"
    },
    // 底部
    foo:{
        about:'Tentang kami',
        support:'Dukungan pengguna',
        contact:'Hubungi kami',
        qq:'QQ',
        email:'Surel',
    },
    // 行情
    market:{
		handicap:"Rintangan",
        exchange:'Menukarkan',
        selfmarket:'Favorit',
        allmarket:'Semua',
        symbol:'Pasangan',
        newprice:'Harga terakhir',
        change:'Mengubah',
        highprice:'Tinggi',
        lowprice:'Rendah',
        vol:'24H Vol',
    },
    // 公共交易
    td:{
        buy:'membeli',
        sell:'menjual',
        currency:'mata uang',
        num:'nomor',
        time:'waktu',
        limit:'membatasi',
        price:'Patokan harga',
        method:'cara bayar',
        total:'Total',
        inwant:'Mohon masukkan',
        do:'operasi',
        more:'Muat lebih banyak',
        nomore:'Tidak lagi',
        nodata:'Tidak ada data',
        trade:'berdagang',
        buynum:'jumlah pembelian',
        sellout:'Menjual ',
        buyin:'Membeli',
        all:'semua',
        allbuy:'Beli semua',
        allsell:'Jual semua',
        buytotal:'Silakan masukkan jumlah total yang ingin Anda beli.',
        selltotal:'Silakan masukkan jumlah total yang ingin Anda jual.',
        buyallnum:'Silakan masukkan jumlah yang ingin Anda beli.',
        sellallnum:'Silakan masukkan jumlah yang ingin Anda jual.',
        tradeTotal:'Total volume transaksi',
        doceil:'Batalkan secara otomatis dalam hitungan detik',
        place:'Memesan',
        waitpay:'Pembayaran tertunda',
        paycode:'Kode pembayaran',
        finished:'Lengkap',
        ceiled:'Dibatalkan',
        payed:'Dibayar',
        nofinish:'tidak lengkap',   
        buyer:'Pembeli',
        seller:'penjual',
        callWay:'cara kontak',
        placeTime:'Waktu pemesanan',
        renum:'Nomor referensi',
        canceil:'membatalkan',
        confirm:'Konfirmasi',
        pwd:'Silakan masukkan kata sandi transaksi.',
        coincode:'Satuan uang',
        pcoin:'Silakan pilih satuan moneter.'
    },
    // 法币交易
    fat:{
        // LegalPayDetail
        orderLog:'Catatan pesanan',
        fatdLog:'catatan perdagangan legal',
        shoper:'bisnis',
        faLog:'catatan perdagangan legal',
        tdType:'Tipe transaksi',
        odStatus:'Status pemesanan',
        pwaitPay:'Mohon menunggu pembeli untuk membayar',
        odFinish:'Pesanan telah selesai',
        odCeil:'Pesanan telah dibatalkan',
        odPay:'Pembayaran telah dilakukan. Silakan periksa informasi pembayaran dengan hati-hati.',
        tdCeil:'Batalkan transaksi',
        pCeil:'Jika Anda sudah membayar, jangan dibatalkan',
        paySure:'Konfirmasi pembayaran',
        pdopay:'Mohon konfirmasi bahwa Anda telah membayar',
        badClick:'Klik berbahaya akan membekukan akun secara langsung',
        receivePay:'Konfirmasi tanda terima',
        payReceive:'Harap konfirmasi bahwa pembeli telah membayar Anda.',
        receivePays:'Konfirmasi piutang',
        // LegalPay
        payPlease:'Tolong bayar',
        tdPrice:'Patokan harga',
        tdNum:'Volume transaksi',
        payinfo:'Informasi Pembayaran',
        banknum:'akun bank',
        realName:'Nama asli',
        shoperZname:'Cabang pembantu pedagang',
        shoperNum:'Akun pedagang',
        odCeil:'Batalkan pesanan',
        imPay:'telah membayar, Konfirmasi',
        // LegalSeller
        register_time:'Waktu pendaftaran',
        odtotal:'Lembar perakitan',
        odmonth:'lembar 30 hari',
        odfinish:'Lembar penyelesaian',
        odrate:'Tingkat penyelesaian',
        submit:'menerbitkan',
        phone:'telepon',
        mysell:'penjualan saya',
        mybuy:'pembelian saya',
        realAuth:'Otentikasi nama asli',
        advAuth:'Otentikasi lanjutan',
        linebuy:'Pembelian online',
        linesell:'Jual online',
        tipPay:'Silakan hubungi pedagang untuk pembayaran dalam waktu 24 jam. Jika pembayaran melebihi 24 jam, itu akan dibatalkan secara otomatis.',
        notlow:'Tidak kurang dari batas minimum',
        nothigh:'Jangan melebihi batas maksimum',
        notnum:'Jangan melebihi jumlah maksimum',
        // LegalShopDetail
        type:'Tipe',
        status:'status',
        seeOrder:'Tampilan Pemesanan',
        withdraw:'menarik',
        abnormal:'abnormal',
        lowershelf:'Rak bawah',
        protection:'Perlindungan hak',
	    apply:'Terapkan perlindungan hak',
        psType:'Silakan pilih jenisnya',
        pselect:'Tolong pilih',
        alipay:'Alipay',
        wechat:'Wechat',
        bank:'kartu bank',
        minNum:'Volume perdagangan minimum',
        maxNum:'Volume perdagangan maksimum',
        wantBuy:'ingin membeli',
        pnums:'Silakan masukkan jumlah',
        pmin:'Silakan masukkan volume transaksi minimum',
        pmax:'Silakan masukkan volume perdagangan maksimum',
        pnot:'Volume perdagangan maksimum tidak boleh kurang dari volume perdagangan minimum',
        // MyLegalShops
        myshops:'toko pribadi',
        name:'Nama',
        fiatSub:'Legal tender',
        shoper_balance:'Saldo pedagang',
        enterShop:'Masuk toko',
        // shop_legal_pay_detail
        payedWait:'Pembayaran dilakukan menunggu verifikasi',
        yes:'YA',
        no:'TIDAK',
        sd:'Kunci keseimbangan',
        journal:'Log saldo',
        business:'bisnis',
        user:'pengguna',
        backdone:'ditarik',
        busbalance:'Saldo pedagang',
		userbalance:'Saldo pengguna',
    },
    ctc:{
        ctc:'C2C',
        myRelease:'Rilis C2C saya',
        myTrade:'C2C saya berdagang',
        and:'Ya',
        balance:'keseimbangan',
        buynum:'Membeli volume',
        sellnum:'Jual volume',
        bankTransfer:'transfer Bank',
        payim:'Harus bayar sendiri',
        pbuyNum:'masukkan jumlah pembelian',
        pprice:'Silakan masukkan harga satuan',
        payway:'Silahkan pilih cara pembayaran.',
        psellNum:'Harap masukkan jumlah yang terjual.',
        suerePlace:'Apakah Anda mengkonfirmasi pesanan?',
        detail:'detail',
        payinfo:'Informasi Pembayaran',
        Payee:'penerima pembayaran',
        total:'Total',
        name:'nama',
        cardnum:'Nomor kartu',
        receivePay:'Konfirmasi piutang',
        ceilConfirm:'Konfirmasi batalkan transaksi?',
        paySeller:'Harap konfirmasikan bahwa Anda telah membayar penjual, klik berbahaya akan membekukan akun.',
        payBuyer:'Mohon konfirmasi bahwa Anda telah menerima informasi pembayaran dari pembeli.',
        account:'Nomor akun',
        sellerPay:'Mohon konfirmasi bahwa pembeli telah membayar Anda?',
        payattion:'Harap bayar ke penjual sesegera mungkin setelah konfirmasi pembayaran, klik berbahaya akan langsung membekukan akun.',
        log:'c2c telah menyelesaikan pesanan'
    },
    // 合约
    lever:{
        nowentrust:'Buka pesanan',
        hisentrust:'Riwayat pesanan',
        lvchi:'Posisi leverage',
        all:'semua',
        or:'atau',
        gotrade:'Mulai berdagang',
        tdrecord:'Catatan transaksi',
        dealed:'Lengkap',
        notdeal:'Tidak sepakat',
        loading:'Memuat',
        entotal:'Total jumlah yang dipercayakan',
        canuse:'tersedia',
        std: 'Pasar',
        xtd: 'Membatasi',
        pprice: 'Silakan masukkan harganya',
        phand: 'Silakan masukkan jumlah pembelian',
        phandsell:'Silakan masukkan jumlah tangan untuk dijual',
        pwd: 'kata sandi',
        ppwd: 'Silakan masukkan kata sandi transaksi',
        psw: 'kata sandi transaksi',
        equal: 'sama dengan',
        times: 'waktu',
        timed: 'banyak',
        hand: 'tangan',
        hands: 'tangan',
        ptimes: 'Silakan pilih kelipatan',
        phands: 'Silakan pilih jumlah tangan',
        contractVal: 'nilai pasar kontrak',
        bail: 'Batas',
        canBail: 'Margin yang tersedia',
        charge: 'biaya layanan transaksi',
        domore: 'Beli (panjang)',
        doshort: 'memandang remeh)',
        dmore: 'Panjang',
        dshort: 'Pendek',
        sureOd: 'konfirmasi pemesanan',
        noless: 'Jumlah tangan tidak boleh lebih rendah dari',
        nomore: 'Jumlah tangan tidak boleh lebih dari',
        tdnum: 'Total',
        risk: 'tingkat risiko',
        allloss: 'total posisi untung dan rugi',
        onehouse: 'Satu tombol ditutup',
        type: 'Tipe',
        entrustPrice: 'harga komisi',
        openPrice: 'harga pembukaan',
        nowPrice: 'harga sekarang',
        styPrice: 'Ambil untung harga',
        stsPrice: 'Harga Stop Loss',
        openTime: 'waktu buka',
        closeTime: 'waktu tutup',
        rate: 'Biaya penanganan',
        nightFee: 'biaya semalam',
        loss: 'laba rugi',
        setloss: 'Setel stop loss stop loss',
        expectProfit: 'keuntungan yang diharapkan',
        expectLoss: 'kerugian yang diharapkan',
        allClose: 'Semua penutupan',
        moreClose: 'Hanya datar lebih dari satu',
        nullClose: 'Hanya single kosong',
        sureClose: 'Konfirmasi posisi? ',
        thanZearo: 'Nilai yang ditetapkan harus lebih besar dari 0',
        listin: 'Pesanan tertunda',
        tdin: 'dalam transaksi',
        closein: 'Tutup posisi',
        closed: 'Tertutup',
        revoked: 'dicabut',
        revokeOrder: 'Apakah Anda yakin akan membatalkan pesanan?',
        ping:'Tutup posisi',
        revoke:'Membatalkan',
        sureping:'Tentukan penutupannya?',
        thanzone:'Nilai yang ditetapkan harus lebih besar dari 0'
       
    },
    // 币币
    cuy:{
         direction: 'arah',
         total: 'total',
         price: 'harga',
         sell: 'menjual',
         buy: 'membeli',
         allStation: 'Perdagangan pasar',
         buyPrice: 'Harga',
         buynum: 'Jumlah',
         sellPrice: 'Harga',
         sellnum: 'Jumlah',
         tdPrice: 'Total',
         or:'atau',
         tdStart: 'Mulai berdagang',
         pbPrice: 'Silakan masukkan harga penawaran',
         pbNum: 'Silakan masukkan jumlah pembelian',
         psPrice: 'Silakan masukkan harga jual',
         psNum: 'Silakan masukkan jumlah penjualan',
         fixPrice: 'Membatasi',
         Mtrans: 'Pasar',
         available: 'tersedia',
         revoke: 'Membuka',
         loading: 'Memuat',
         confirmCancel: 'Anda yakin ingin membatalkan? ',
         confirm: 'Oke',
         cancel: 'Membatalkan',
         nomore: 'Tidak ada data lagi',
         evelPrice: 'Harga rata-rata'
     },
    // 资产
    asset:{
		confirmhuazhuan:"Apakah Anda mengkonfirmasi transfer?",
        assets: 'aktiva',
        currency_account: 'akun koin',
        lever_account: 'akun leverage',
        fince_account: 'akun fiat',
        change_account: 'akun transaksi',
        micro_account:'Akun Kontrak Kedua',
        miscroAccount: 'Akun Kontrak Kedua',
        assets_hua: 'Transfer dana',
        all_assets: 'total aset',
        currency: 'mata uang',
        canuse: 'tersedia',
        frezz: 'membeku',
        conversion: 'Melipat',
        charging: 'Menyetorkan',
        withdraw: 'Menarik',
        address_bind:'mengikat menarik alamat',
        address_withdraw: 'Manajemen alamat perdagangan',
        record: 'catatan',
        tbrecord:'Tarik Rekam',
        address_charge: 'Alamat biaya',
        address_width: 'Alamat Tiket',
        copy: 'salinan',
        ercode: 'Kode QR',
        reminder: 'tips hangat',
        notcharge: 'Jangan mengisi ulang salah satu alamat di atas',
        ornone: ', jika tidak, aset tidak akan dipulihkan',
        support: 'Koin hanya mendukung metode pengiriman sederhana. Penggunaan metode lain (kirim semua) untuk sementara tidak dapat dikreditkan. Mohon mengertilah.',
        minnum: 'jumlah minimum koin{min}~{max}',
        ratenum: 'biaya biaya',
        havenum: 'jumlah kedatangan',
        from: 'Dari',
        to: 'ke',
        transfer: 'menggesekkan',
        tfnum: 'jumlah transfer',
        ptfnum: 'Silakan masukkan yang terendah',
        dtfnum: 'jumlah pukulan',
        canbalance: 'Saldo Tersedia',
        sureConfirm: 'konfirmasi transfer',
        moneyRecord: 'catatan keuangan',
        pNum: 'Silakan masukkan nomor transfer',
        leverUse: 'Akun leverage tersedia',
        legalUse: 'Akun Fiat tersedia',
		changeUselg:'Akun koin tersedia',
        changeUse: 'Akun transaksi tersedia',
        microuse: 'Akun kontrak kedua tersedia',
        look: 'Melihat',
        chargeRecord: 'catatan mata uang yang dibebankan',
        status: 'Status pelacakan',
        noopen: 'Fitur ini belum terbuka',
        enterAdderses: 'Silakan masukkan alamat koin',
        enterNum: 'Silakan masukkan jumlah koin',
        lessMin: 'Jumlah koin yang dimasukkan kurang dari jumlah minimum',
        tips01: 'Jangan mengisi ulang aset lain ke alamat di atas, jika tidak, aset tidak akan dipulihkan. ',
        tips02: 'Mata uang hanya mendukung metode kirim sederhana, penggunaan metode lain (kirim semua) untuk mata uang tidak dapat dipertanggungjawabkan sementara, harap dipahami. ',
        beizhu: 'Catatan',
        pbeizhu: 'Silakan masukkan catatan',
        add: 'menambahkan',
        addressList: 'daftar alamat',
        delete: 'menghapus',
        norec: 'tidak ada catatan',
        selectCurrency: 'Silakan pilih mata uang',
        chainType:"Jenis rantai",
        ThreeChannel:"Saluran Tripartite",
        AboutRate:"Kurse pertukaran{rate}Sekitar sama dengan",
        OnlineBanking:"Bankan online",
        ScanCode:"Kode imbas"
    },
    // 账户设置
    set:{
        mycode2:'Kode otorisasi saya',
        copycode2:'Salin kode otorisasi',
        uaccont: 'Tingkat keamanan akun Anda:',
        strong: 'kuat',
        middle: 'tengah',
        weak: 'lemah',
        min: 'rendah',
        heigh: 'tinggi',
        complete: 'Lengkapi informasi lebih lanjut untuk memastikan keamanan akun',
        mycode: 'kode undangan saya',
        copycode: 'Salin kode undangan',
        bindphone: 'Ikat telepon',
        bindemail: 'Mengikat Kotak Surat',
        loginpwd: 'kata sandi masuk',
        noBind: 'tidak terikat',
        binds: 'mengikat',
        bind: 'mengikat',
        binded: 'mengikat',
        net: 'Akun Internet berisiko dicuri. Anda disarankan untuk mengubah kata sandi secara berkala untuk melindungi akun Anda.',
        reset: 'Memodifikasi',
        setPsw: 'Tetapkan kata sandi transaksi untuk memastikan keamanan transaksi. ',
        goSet: 'Pergi untuk mengatur',
        bindAccount: 'Mengikat akun penebusan',
        duihuan: 'Ikat akun untuk menukarkan poin',
        copysuccess: 'Salin sukses',
        copyfail: 'penyalinan gagal',
        recopy: 'Silakan salin lagi',
        account: 'Akun',
        detail: 'detail',
        val: 'jumlah',
        forgetPsw: 'Tidak ingat kata sandi',
        code: 'Kode verifikasi',
        getCode: 'Ambil kode',
        setPsw: 'atur kata sandi',
        enterPsw: 'Silakan masukkan kata sandi',
        pswFalse: 'Kata sandi yang dimasukkan dua kali tidak konsisten',
        enterPswagain: 'Silakan masukkan kata sandi Anda lagi',
        jsetPsw:'Siapkan kata sandi transaksi',
        jenterPsw:'Silakan masukkan kata sandi transaksi',
        jenterPswagain:'Silakan masukkan kembali kata sandi transaksi',
        enterAccount: 'Silakan masukkan akun',
        enterCode: 'Silakan masukkan kode verifikasi',
        accountFalse: 'Telepon atau akun email yang Anda masukkan tidak memenuhi aturan!',
        second: 'kedua',
        sendCode: 'Kirim',
        sendsucc:'kirim sukses',
        enterPswTwo: 'Silakan masukkan kata sandi dua kali',
        rest: 'tersisa',
        yes: 'Ya',
        no: 'Tidak',
        yorn: 'Apakah akan Menyetel Kata Sandi Transaksi',
    },
    // 身份认证
    auth:{
         identity: 'Autentikasi',
         name: 'nama',
         idcard: 'dokumen identitas',
         upimg: 'Silakan unggah foto dokumen identitas, yang pertama adalah bagian depan, yang kedua adalah bagian belakang, dan yang ketiga adalah foto bagian depan dari dokumen identitas yang dipegang.',
         submit: 'Kirimkan',
         auditing: 'Audit...',
         certified: 'Bersertifikat!',
         pname: 'Silakan masukkan nama',
         pidcard: 'Silakan masukkan nomor ID',
         pimg: 'Silakan unggah gambar sertifikat!',
     },
    // 收款方式
    seting:{
         pmethod: 'Cara Pembayaran',
         truename: 'nama asli',
         opening: 'nama Bank',
         bank: 'nomor kartu bank',
         alipay: 'Akun Alipay',
         wename: 'Nama panggilan WeChat',
         wechat: 'akun WeChat',
         pname: 'Silakan masukkan nama asli Anda',
         popen: 'Silakan masukkan nama nama bank',
         pcard: 'Silakan masukkan nomor kartu bank',
         palipay: 'Silakan masukkan akun Alipay',
         Pwname: 'Silakan masukkan nama panggilan WeChat',
         pwaccount: 'Silakan masuk ke akun WeChat',
         pimg1: 'Kode koleksi Wechat',
         pimg2: 'Kode pembayaran Alipay'
     },
    // 帮助中心
    news:{
         seeall: 'Lihat semua',
         helpcenter: 'Pusat Bantuan',
         back:'Kembali'

     },
    //登录
    login:{
        welcome: 'Selamat datang untuk masuk',
        phoneLogin: 'Seluler',
        emailLogin: 'kotak surat',
        account: 'Akun',
        psw: 'kata sandi',
        login: 'Gabung',
        nouser: 'Bukan pengguna ETHEREUM? ',
        goRegister: "Daftar sekarang dan mulai berdagang di platform perdagangan aset digital terkemuka di dunia",
        registerFree: 'pendaftaran gratis',
        psw6: "Kata sandi tidak boleh kurang dari enam"
    },
    register:{
        register: 'Daftar',
        phoneRegister: 'Seluler',
        emailRegister: 'kotak surat',
        country: 'kebangsaan',
        enterPhone: 'Silakan masukkan nomor telepon',
        enterEmail: 'Silahkan masuk ke kotak surat',
        psw16: 'Kata sandi antara 6-16',
        inviteCode: 'Kode Undangan',
        sel: 'Harus diisi',
        sel2:'tidak dibutuhkan',
        read: 'Saya telah membaca dan setuju',
        xieyi: 'Perjanjian Pengguna',
        tips01: 'Jangan mengubah informasi kewarganegaraan setelah pendaftaran, pastikan untuk memilihnya.',
        tips02: 'Email verifikasi mungkin salah diidentifikasi sebagai spam, harap periksa.',
        tips03: 'Harap simpan akun ETHEREUM dan kata sandi login Anda.',
        tips04: 'Jangan gunakan password login yang sama dengan website lain. ',
        emailFalse: 'Kotak surat yang Anda masukkan tidak sesuai dengan aturan'
    },
    // 积分兑换
    jc:{
        title:'Platform BEAU Aset Digital Konvertibel JC',
        balance:'keseimbangan',
        cannum:'Tersedia JC Kuantitas',
        new:'Harga Terbaru',
        exnum:'Kuantitas Pertukaran',
        pnum:'Silakan masukkan nomor JC',
        canex:'Kuantitas BEAU yang Dapat Dikonversi',
        exnow:'Menukarkan',
        record:'Catatan Pertukaran',
        exprice:'harga pertukaran',
        extime:'Waktu pertukaran',
        not:'Jumlah integral yang tersedia tidak mencukupi',
        usenum:'Gunakan Kuantitas JC',
        out:'KELUAR',
        gotd:'Untuk berdagang'
    },
    coin:{
        manage: 'Keuangan',
        total: 'total setoran',
        bao: 'uang deposito',
        mybao: 'setoran saya',
        profit: 'perkiraan pendapatan',
        cuntime: 'waktu setoran',
        endtine: 'waktunya'
    },
    team:{
        myteam:'kelompok ku',
        ztnum: 'nomor push langsung',
        activenum: 'jumlah anggota tim yang aktif',
        profit: 'pendapatan',
        back: 'komisi pengembalian',
        cblog: 'catatan pengisian',
        bblog: 'catatan mata uang',
    },
    // k线
    kline: {
        text1: 'Waktu',
        text2: '1 menit',
        text3: '5 menit',
        text4: '15 menit',
        text5: '30 menit',
        text6: '1 jam',
        text7: '1 hari',
        text8: '1 minggu',
        text9: '1 bulan',
    },
    // 秒合约
    miscro: {
        trade: 'Transaksi',
        buyPrice: 'Harga pembelian',
        finshPrice: 'Harga transaksi',
        loss: 'Perkiraan untung dan rugi',
        times: 'Hitung mundur',
        mode: 'Modus transaksi',
        num: 'Kuantitas pembukaan',
        rate: 'Tingkat keuntungan',
        up: 'Memborong',
        down: 'Beli atau jatuh',
        openNum: 'Silakan masukkan jumlah pembukaan',
        success: 'Sukses dalam menempatkan pesanan!',
        c2c: "akun fiat",
        complaint: "Saran keluhan",
        reply: "Silakan tulis pertanyaan Anda dan kami akan membalas Anda sesegera mungkin...",
        complaintList: "Daftar Saran Pengaduan",
        complaintReply: "Membalas:",
        complaintDescription: "Silakan masukkan deskripsi",
        resetpwd: "Ubah kata sandi",
        foundedOn: "Didirikan pada",
        commonProblem: "Masalah umum",
        statement: "Pernyataan interpretatif",
        about: "Tentang Ethereum",
        everyone: "Semua orang adalah CEO",
        program: "Program Mitra Global ETHEREUM",
        program2: "Mitra",
        myMine: "Tambang saya:",
        friend: "Teman saya:",
        myRank: "peringkat saya:",
        accumulated: "Akumulasi komisi:",
        copyLinks: "Salinan",
        moneyVein: "Hubungan orang berubah menjadi urat uang",
        example: "Contoh komisi",
        enterQuantity: "Silakan masukkan jumlah",
        contractBalance: "Saldo akun kontrak",
        submitRepeatedly: "Dalam pengajuan, tolong jangan mengirimkan berulang kali",
        alipayCode: "Kode pembayaran Alipay",
        wechatCode: "Kode Tanda Terima Wechat",
        realPrice: "Harga waktu nyata",
        currencyExchange: "Penukaran mata uang",
        currencyExchangeIn: "Penukaran mata uang",
        cashableBalance: "Saldo yang dapat diuangkan：",
        minimumCashable: "Minimum Dapat Diuangkan：",
        maximumCashable: "Maksimum Dapat Diuangkan：",
        automaticallys: "Setelah mengklik pertukaran, itu akan selesai secara otomatis dan tidak dapat dikembalikan.",
        match:"Cocok",
        title:"Konvertibilitas aset",
        holdAssets:"Memegang aset",
        dangerousCurrency:"Memegang mata uang berbahaya",
        convertibleQuantity:"Kuantitas yang Dapat Dikonversi",
        currencyExchanges:"Nilai tukar mata uang：",
        insuranceCurrency:"Mata uang asuransi",
        insuranceType:"Jenis asuransi",
        contractAsset:"Asuransi Aset Kontrak",
        warehouses:"Jumlah Gudang",
        availableAssets:"Aset yang tersedia:",
        insuredAssets:"Aset yang diasuransikan:",
        insuredAssets1:"Aset yang diasuransikan",
        insuranceAssets:"Aset asuransi:",
        purchaseInsurance:"Beli asuransi",
        insuranceClaims:"Klaim asuransi",
        insuranceCancellation:"Pembatalan asuransi",
        coinWallet:"Dompet Koin Asuransi",
        bmbWallet:"Dompet HAP",
        cumulativeCoins:"Koin kumulatif：",
        availableQuantity:"Kuantitas yang tersedia:",
        rawCurrency:"Catatan mata uang mentah",
        contractInsurance:"Asuransi kontrak",
        tenThousand:"sepuluh ribu",
        runningLow:"Maaf, kredit Anda hampir habis",
        purchase:"Jumlah yang Anda masukkan tidak sesuai dengan aturan. Kuota pembelian Anda adalah",
        reach:"mencapai",
        between:"di antara",
        onlyEnter:"Anda hanya bisa masuk",
        integersBetween:"Bilangan bulat antara",
        notReturned:"Klik untuk membeli asuransi, sebagai pemahaman rinci tentang perjanjian asuransi dan setuju bahwa gudang secara otomatis akan berlaku, tidak dapat dikembalikan.",
        settled:"Apabila harta benda yang dipertanggungkan kehilangan uang dan tidak dapat melakukan pemesanan, maka klaim asuransi akan diselesaikan.",
        profitable:"Ketika aset menguntungkan",
        terminated:"pada saat itu, asuransi akan otomatis dihentikan.",
        automatically:"Ketika aset yang diasuransikan kehilangan 50%, mereka harus mengajukan klaim asuransi, jika tidak, mereka tidak dapat diperdagangkan. Ketika keuntungan 100%, asuransi secara otomatis akan membatalkan kontrak. Gudang hanya bisa membayar dua kali sehari, lebih dari dua kali, t+1.",
        termination:"Setelah pemutusan kontrak asuransi, aset yang diasuransikan dapat dikonversi. Setelah pemutusan kontrak, aset yang diasuransikan dianggap melanggar kontrak, dan gudang dibersihkan secara otomatis.",
        just:"hanya",
        back:"kembali",
        lowestNumber:"Angka terendah adalah",
        confirmExchange:"Apakah Anda mengkonfirmasi pertukaran?",
        contractValuation:"Penilaian Aset Akun Kontrak",
        secondValuation:"Penilaian Aset Akun Kontrak Kedua",
        falshValuation:"Penilaian aset di akun flash",
        c2cValuation:"Penilaian Aset dari Akun fiat",
        recordWithdrawal:"Catatan penarikan uang",
        category:"kategori",
        safetyCenter:"Pusat Keamanan",
        safeText1:"Registrasi, modifikasi kata sandi, dan pengaturan keamanan untuk menerima SMS yang divalidasi",
        safeText2:"Akun internet berisiko dicuri. Disarankan agar Anda mengubah kata sandi secara teratur untuk melindungi keamanan akun.",
        flashTrading:"Perdagangan Kilat",
        assetCenter:"Pusat Aset",
        promotionCode:"Kode Promosi Saya",
        loginAgain:"Log masuk kedaluwarsa, silakan masuk lagi",
        text10:"Harga Real-time Berdasarkan HAP",
        text11: "Kode Otorisasi"


    },
    bank:{
        BindingCard:"Kartu bank terikat",
        name:"Nama",
        PayeeName:"Nama penerima",
        bankName:"Nama Bank/Kode bank",
        PayeeAdd:"Alamat pembayaran",
        submit:"Kirim",
        fee:"Koleksi",
        selectBank:"Silakan pilih bank"
    }
}


// WEBPACK FOOTER //
// ./src/lang/en.js